import tw, { styled } from 'twin.macro';

export const ForgotPasswordWrapper = styled.div`
  ${tw`flex justify-end`};
`;

export const TipsWrapper = styled.article`
  ${tw`text-black relative px-4`};
  width: 95%;

  .container {
    ${tw`flex justify-between items-center relative overflow-hidden`};
    height: fit-content;
    min-height: 420px;
  }
  
  .tip {
    ${tw`flex flex-col justify-center items-center absolute top-0 left-0 w-full h-full overflow-hidden opacity-0`};
    transition: all 0.5s ease-in-out;
    
    &.active {
      ${tw`transform opacity-100 translate-x-0`};
    }
    
    &.next {
      ${tw`transform translate-x-full`};
    }

    &.last {
      ${tw`transform -translate-x-full`};
    }

    .image {
      ${tw`relative text-center`};
      padding-left: 10px;
      
      img {
        object-fit: contain;
        height: 150px;
      }
    }

    .info {
      font-family: Circular Std !important;
      text-align: center;
      
      h4 {
        font-family: Circular Std !important;
        color: #007996;
        font-size: 20px;
        margin: 15px 0;
        padding: 0;
      }
      
      p {
        font-family: Circular Std !important;
        color: #007996;
        font-weight: 400;
        font-size: 15px;
      }
      
      ul {
        ${tw`p-0 m-0 text-left pl-4 font-normal`};
        color: #007996;
        font-size: 14px;
        
        li {
          line-height: 25px;
        }
      }
    }
  }
   
  .indicators {
    ${tw`flex flex-row justify-center gap-4`};
    
    .indicator {
      transition: all 0.5s ease-in-out;
      background-color: #ddd;
      border-radius: 10px;
      height: 5px;
      width: 10px;
    
      &.active {
        background-color: #007996;
        width: 20px;
      }
    }
  }
  
  .navigation {
    ${tw`flex items-center justify-end`};

    button.link:not(.disabled) img {
      ${tw`w-6`};
    }
  }
`;

export const FeedbackWrapper = styled.p`
  ${tw`text-center leading-normal mb-4 py-3 rounded-lg`};
  font-family: Circular Std !important;
  border: 1px solid #28a744;
  color: #28a744;
  font-size: 14px;

  a {
    ${tw`cursor-pointer`};
  }

  &.warning {
    border-color: orange;
    color: orange;
  }
  
  &.error {
    border-color: #ff6e5b;
    color: #ff6e5b;
  }
`;

export const FormWrapper = styled.form`
  ${tw`flex flex-col gap-8 py-10 md:py-20 px-10 mx-auto xl:w-8/12 h-full`};
  
  span.required {
    color: black !important;
  }
  
  @media only screen and (max-width: 768px) {
    ${tw`w-2/3 px-8`};
  }
  
  @media only screen and (max-width: 540px) {
    ${tw`w-11/12`};
  }
  
  @media only screen and (max-width: 420px) {
    ${tw`w-full`};
  }

  .header {
    border-bottom: 0.5px solid #1e4f6a26;
    ${tw`pb-8`};

    h1 {
      font-family: Circular Std !important;
      line-height: 100%;
      font-weight: 500;
      color: #252525;
      font-size: 36px;
    }
    
    p {
      font-family: Circular Std !important;
      line-height: 28px;
      font-weight: 450;
      color: #8692A6;
      font-size: 16px;
    }
  }
  
  .footer {
    .google-btn {
      color: #696f79;
    }

    .separator {
      ${tw`text-center py-6 block`};
      font-family: Circular Std !important;
    }
    
    .alternate-page {
      ${tw`mt-8 text-center`};
      font-family: Circular Std !important;

      span {
        ${tw`text-mainBlue underline font-medium cursor-pointer`};
        font-family: Circular Std !important
      }
    }
  }
`;

export const AuthWrapper = styled.div`
  ${tw`flex overflow-hidden h-screen`};
  
  .left {
    ${tw`relative h-screen flex justify-center items-center bg-cover bg-no-repeat overflow-x-hidden text-black`};
    background-image: url('https://storage.googleapis.com/fplsblog/new-auth/left_background.svg');
    width: 42%;

    @media only screen and (max-width: 768px) {
      ${tw`hidden`};
    }
  }

  .right {
    ${tw`relative bg-white h-screen overflow-x-hidden`};
    width: 58%;

    @media only screen and (max-width: 768px) {
      width: 100%;
    }
  }
`;

export const LogoWrapper = styled.a`
  ${tw`hidden w-full p-6 text-left absolute left-0 top-0 outline-none hover:outline-none shadow-none`};
  z-index: 9999;

  &:not(.mobile) {
    ${tw`block`};
  }

  &.mobile {
    @media only screen and (max-width: 768px) {
      ${tw`block relative text-center`};
    }
  }
  
  img {
    max-height: 40px;
    width: 85px;

    @media only screen and (max-width: 768px) {
      max-height: 50px;
    }
  }
`;